export const SECTION_CONSTS = {
    GET_SECTIONS: "GET_SECTIONS",
    CREATE_SECTION: "CREATE_SECTION",
    UPDATE_SECTIONS_POSITIONS: "UPDATE_SECTIONS_POSITIONS",
    UPDATE_SECTION_BY_ID: "UPDATE_SECTION_BY_ID",
    DELETE_SECTION_BY_ID: "DELETE_SECTION_BY_ID",
};
